import axios from "axios";

export function callOnBoardingApi(payload: object) {
  return axios("/api/Users/createUserAccount", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    data: JSON.stringify(payload)
  });
}
